import { API_URL } from "../Config";
import { PageResult } from "../Pagination";

export interface IComplianceInvestigationEffect {
  cieffectid: string;
  effect: string;
  likelihood: string;
  severity: string;
  riskscore: string;
  description: string;
  complianceinvestigationid: string;
}

export interface IComplianceInvestigatioEffectList extends PageResult {
  list: IComplianceInvestigationEffect[];
}

export const GetComplianceInvestigationEffectsFetchUrl = (
  complianceInvestigationId: string,
  pageNo: number,
  recordsPerPage: number,
  searchText: string,
  filters: any
) => {
  var params = `&page=${pageNo}&per_page=${recordsPerPage}`;

  let url = `${API_URL}/Ci/listcieffects?ci_id=${complianceInvestigationId}${params}`;

  if (process.env.REACT_APP_EPA_ENV === "localhost") {
    url = `${API_URL}/ci-effects`;
  }

  return url;
};
